// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SimulationTarget, SimulationTargetT, verifySimulationTarget } from "./simulation-target";

export class SimulationTargetList implements flatbuffers.IUnpackableObject<SimulationTargetListT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationTargetList {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationTargetList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationTargetList,
  ): SimulationTargetList {
    return (obj || new SimulationTargetList()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimulationTargetList(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationTargetList,
  ): SimulationTargetList {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationTargetList()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  targets(index: number, obj?: SimulationTarget): SimulationTarget | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new SimulationTarget()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  targetsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startSimulationTargetList(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addTargets(builder: flatbuffers.Builder, targetsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, targetsOffset, 0);
  }

  static createTargetsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startTargetsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endSimulationTargetList(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSimulationTargetList(
    builder: flatbuffers.Builder,
    targetsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SimulationTargetList.startSimulationTargetList(builder);
    SimulationTargetList.addTargets(builder, targetsOffset);
    return SimulationTargetList.endSimulationTargetList(builder);
  }

  unpack(): SimulationTargetListT {
    return new SimulationTargetListT(
      this.bb!.createObjList<SimulationTarget, SimulationTargetT>(
        this.targets.bind(this),
        this.targetsLength(),
      ),
    );
  }

  unpackTo(_o: SimulationTargetListT): void {
    _o.targets = this.bb!.createObjList<SimulationTarget, SimulationTargetT>(
      this.targets.bind(this),
      this.targetsLength(),
    );
  }

  unpackFields(...fields: string[]): SimulationTargetListT {
    const t = new SimulationTargetListT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("targets")) {
      t.targets = this.bb!.createObjList<SimulationTarget, SimulationTargetT>(
        this.targets.bind(this),
        this.targetsLength(),
      );
    }
    return t;
  }
}

export class SimulationTargetListT implements flatbuffers.IGeneratedObject {
  constructor(public targets: SimulationTargetT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const targets = SimulationTargetList.createTargetsVector(
      builder,
      builder.createObjectOffsetList(this.targets),
    );

    return SimulationTargetList.createSimulationTargetList(builder, targets);
  }

  clone(): SimulationTargetListT {
    const obj = new SimulationTargetListT();
    obj.targets = this.targets.map((e) => e.clone());
    return obj;
  }

  equals(other: SimulationTargetListT): boolean {
    if (this.targets.length !== other.targets.length) return false;
    for (let i = 0; i < this.targets.length; i++) {
      const a = this.targets[i];
      const b = other.targets[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifySimulationTargetList(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationTarget);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
